import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconPullRequest: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPullRequest"><Circle cx="6" cy="6" r="2.5" stroke="currentColor"/><Circle cx="6" cy="18" r="2.5" stroke="currentColor"/><Circle cx="18" cy="18" r="2.5" stroke="currentColor"/><Path d="M6 8.5V15.5" stroke="currentColor" strokeLinecap="square" strokeLinejoin="round"/><Path d="M12 6H18V15.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14 3.5L11.5 6L14 8.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconPullRequest;
